import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { SecurityService } from '../service';

@Injectable({
  providedIn: 'root'
})
export class HomeGuard implements CanActivate {

  constructor(private readonly router: Router,
    private readonly securityService: SecurityService,
    ) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

    return new Observable(subscriber => {
      if (this.securityService.usuarioSessao) {
        subscriber.next(true);
        subscriber.complete();
      } else {
        this.router.navigateByUrl('/');
        subscriber.next(false);
        subscriber.complete();
      }

    });
  }
}
